<template lang="pug">
.d-video-info
</template>

<script lang="js">

export default {
  name: 'VideoInfoDisplay',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.d-video-info {
}
</style>
